<template>
  <div><slot></slot></div>
</template>
<script>
export default {
  name: 'ExpansionGroup',
  methods: {
    closeOtherPanels(id) {
      this.$children.forEach(child => {
        if (child.close && child._uid !== id)
          child.close();
        else if( child.$children && child.$children[0] && child.$children[0].close && child.$children[0]._uid && child.$children[0]._uid !== id )
          child.$children[0].close();
      });
    }
  }
};
</script>
